import { useState } from 'react';
import  {Stack, Box, Dialog, DialogActions, DialogContent, Tabs, Tab, DialogTitle, FormControl, InputLabel,
  Button, TextField, Select, MenuItem  } from '@mui/material';
import FindGuest from './find_guest.js';
import IconCancel from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import moment from 'moment';
import 'moment/dist/locale/de';

const EditGast = ({open, close, getInfo, getGastInfo, updateChanged, setResChange, updateGastValue, countries, gastdetails, loadGast, getInfoBetten}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [findguest, setFindguest] = useState(false);

  const updateGuest = (field) => (e) => {
    updateGastValue(0, field, e.target.value);
  }

  const selGuest = (id) => (ev) => {
    const old_id = getInfo('id_gast');
    loadGast(id);
    updateChanged(id, 'id_gast');
    getInfoBetten().forEach((b, k) => {
      if (b.id_gast===old_id) {
        setResChange(rc=>{
          const betten = [...rc.betten];
          betten[k].id_gast = id;
          return ({...rc, betten: betten});
        });
      }
    });
    setResChange(rc=>{
      const g = {...rc.gaeste};
      delete g[old_id];
      return ({...rc, gaeste: g});
    });
    setFindguest(false);
  }


//  if (!gastFields) return null;

  return (
    <>
      <Dialog open={open} onClose={close}>
        <DialogActions style={{position:'absolute', right:0}}>
          <Button label="ra.action.cancel" onClick={close}><IconCancel /></Button>
        </DialogActions>
        <DialogTitle sx={{pb:1}}>Edit guest 
            <Button onClick={()=>setFindguest(true)}><SearchIcon /></Button>
            <Button onClick={()=>setFindguest(true)}><AddIcon /></Button>
            </DialogTitle>
        
        <DialogContent sx={{pb:1}}>
          {findguest && <FindGuest setFindguest={setFindguest} selGuest={selGuest} />}
          <Stack direction="row" spacing={2} sx={{pb:1, '& > *':{flex:1}}}>
            <TextField label="First name" value={getGastInfo(0, 'vorname')} onChange={updateGuest('vorname')} />
            <TextField label="Name" value={getGastInfo(0, 'name')} onChange={updateGuest('name')} />
            <TextField label="Date of birth" type="date" value={moment(getGastInfo(0, 'geburtsdatum')+"").format('YYYY-MM-DD')} onChange={updateGuest('geburtsdatum')} />
          </Stack>
          <Stack direction="row" spacing={2} sx={{'& > *':{flex:1}}}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Residence</InputLabel>
              <Select label="Residence" value={getGastInfo(0, 'id_land')} onChange={updateGuest('id_land')}>
    {countries.map((c) => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}  
              </Select>
            </FormControl>
            <TextField label="Passport number" value={getGastInfo(0, 'pass')} onChange={updateGuest('pass')} />
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Nationality</InputLabel>
              <Select label="Nationality" value={getGastInfo(0, 'id_passland')} onChange={updateGuest('id_passland')}>
    {countries.map((c) => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}  
              </Select>
            </FormControl>
          </Stack>
          <TextField label="Remarks" value={getGastInfo(0, 'bemerkungen')} onChange={updateGuest('bemerkungen')} multiline fullWidth />
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={activeTab} onChange={(ev, t)=>setActiveTab(t)}>
    {gastdetails.map((d) => <Tab key={d.id} label={d.titel} />)}              
            </Tabs>
          </Box>
    {gastdetails.map((d, k) => 
          <div key={k} role="tabpanel" hidden={activeTab !== k}>
      {d.fields.map((f, j) => <TextField key={j} label={f} value={getGastInfo(0, 'det-'+d.id+'-'+(j+1))} onChange={updateGuest('det-'+d.id+'-'+(j+1))} sx={{pr:2}} />)}
          </div>
    )}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={close}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EditGast;